export default "__VITE_ASSET__BOS_R3wn__"